<section style="padding-bottom: 40px;margin-top: 60px">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="margin-top: 13vh"><img src="../../../assets/cls-sphere.jpg" alt="CLS logo" width="80" />
                </div>
                <div style="display: flex">
                    <div>
                        <h1 class="title section-title" style="margin-top: 40px; color: #044084; font-size: 46px">404:
                            Page not found.</h1>
                        <h4 style="margin-left: 0; color: #044084; padding-left: 0px; padding-right: 0px;">We are sorry,
                            but the page you are looking for does not exist.</h4><br /><br />
                        <p class="hero-subtitle"
                            style="margin-left: 0; color: #044084; padding-left: 0px; padding-right: 0px; ">Please click
                            <a routerLink="/">here</a> if you wish to return to the home page.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section style="background-color: #f2f5f5; margin-bottom:0; padding-bottom: 40px; padding-top: 60px; margin-top: 10vh">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="title section-title">Need Help?</h1>
                <h6>If you are uncertain, please get in touch and we will be happy to advice.</h6><br />
                <h6>CLS GROUP SERVICES LIMITED</h6>
                <h6>PO Box 574, West Malling, ME6 9PR</h6>
                <h6><a href="mailto:info@clsgroupservices.co.uk">info@clsgroupservices.co.uk</a></h6>
                <h6><a href="tel:+441732753910">+44(0) 1732 753 910</a></h6>
            </div>
        </div>
    </div>
</section>